import React, { Component } from 'react';
import { Grid, Button, Image, Segment } from 'semantic-ui-react';
import '../css/404.css';

const notfound=require('../img/404image.svg');

class NotFound extends Component {
  render() {
    return(
      <Segment id='div404' style={{ padding: '8em 0em', backgroundColor:'#E94A7E' }} vertical>
        <Grid centered>
          <Grid.Row>
            <Image id='image404' src={notfound} style={{padding: '1em 0em'}} size='massive'/>
          </Grid.Row>
          <Grid.Row>
            <h3>Sorry, we can't find the page you're looking for...</h3>
          </Grid.Row>
          <Grid.Row>
            <p id='button404'> <Button className='white-text' style={{backgroundColor: '#5AD0D2'}} href='/home'> Go back home </Button></p>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/js/NotFound.js